
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import messages from './local/index';

// Initialize i18next with language detection and React bindings
i18n
  .use(LanguageDetector)      // Detects user language from browser settings, query string, etc.
  .use(initReactI18next)      // Passes i18n instance to react-i18next
  .init({
    lng: 'ja',                // Default language
    fallbackLng: 'ja',        // Fallback language if translation missing
    debug: false,            // Turn on/off debugging info
    resources: messages,      // Translation resources
    interpolation: {
      escapeValue: false,    // React already escapes, so we can disable this
    },
  })
  .catch((error) => {
    // Gracefully handle initialization errors (e.g., malformed resources)
    console.error('i18next initialization error:', error);
  });

export default i18n;
